import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="footer-inner">
      <p className="footer-disclaimer">
        <AlertTriangle size={16} />
        <strong>Educational use only.</strong> Not a substitute for professional medical advice.
      </p>
      <p className="footer-emergency">
        For emergencies call <strong>911</strong> or go to the nearest emergency department.
      </p>
      
      {/* Legal Links */}
      <div className="footer-legal-links" data-testid="footer-legal-links">
        <Link to="/disclaimer">Medical Disclaimer</Link>
        <span className="footer-divider">|</span>
        <Link to="/terms">Terms of Use</Link>
        <span className="footer-divider">|</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span className="footer-divider">|</span>
        <Link to="/contact">Contact Us</Link>
      </div>

      <div className="footer-links">
        <Link to="/admin-access" className="admin-link" data-testid="admin-link">Admin</Link>
      </div>
      <p className="footer-copyright">&copy; 2026 Uro2Go. Educational platform only. Not medical advice.</p>
    </div>
  </footer>
);

export default Footer;
